<template>
    <ActivityDetailsCard
        activityType="Incentives"
        :title="item.description"
        :entity="item.entity"
        class="incentives-activity-details"
    >
        <template #sub-header>
            <div class="cell">
                <h5>Company:</h5>
                {{ item.details.company?.name }}
            </div>
            <div class="cell">
                <h5>Fiscal Year:</h5>
                {{ item.details.fiscalYear }}
            </div>
            <div class="cell">
                <h5>Ticker:</h5>
                {{ item.details.company?.symbol }}
            </div>
            <div class="cell">
                <h5>Date:</h5>
                {{ new Date(item.effectiveDate).toLocaleDateString() }}
            </div>
        </template>

        <IncentivesDetails :metrics="groups.stip" v-if="groups.stip?.length > 0">
            <template #title>
                <h3>STIP</h3>
            </template>
        </IncentivesDetails>
        <IncentivesDetails :metrics="groups.ltip" v-if="groups.ltip?.length > 0">
            <template #title>
                <h3>LTIP</h3>
            </template>
        </IncentivesDetails>

        <router-link
            :to="{ name: 'executive-page', params: { id: props.item.entity.id }, query: { tab: 'Incentives' } }"
            class="primary-link"
        >
            See Incentives Details
        </router-link>

        <ActivityStockPriceLine :item="item" />
    </ActivityDetailsCard>
</template>
<script setup>
import ActivityDetailsCard from './ActivityDetailsCard.vue'
import ActivityStockPriceLine from './ActivityStockPriceLine.vue'
import IncentivesDetails from '@/pages/ExecutivePage/IncentivesTab/IncentivesDetails.vue'

import { groupBy } from '@/utils/array.js'
import { computed } from 'vue'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const groups = computed(() => groupBy(props.item.details?.metrics ?? [], v => v.incentivePlan))
</script>
<style>
.incentives-activity-details .incentives-details [data-field] {
    display: none;
}

.incentives-activity-details .incentives-details [data-field='metricName'],
.incentives-activity-details .incentives-details [data-field='status'] {
    display: table-cell;
}

.incentives-activity-details .incentives-details [data-field='metricName'] {
    width: 100%;
}

.incentives-activity-details .activity-content .incentives-details + .incentives-details {
    margin-top: 8px;
}

.incentives-activity-details .activity-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.incentives-activity-details .activity-content > a {
    display: block;
    text-align: center;
    width: 100%;
}
</style>
